<template>
  <section id="productMousaSec" class="product-mousa-sec">
    <div class="container">
      <h2 class="section-title section-mousa-title">夢莎逆時雙效保養系列Ⅱ</h2>
      <p>
        <strong>添加核酸成分</strong
        >，維持原有雙效機能，更進一步追求機能性和質感的進化。
        對肌膚更溫柔，讓每天的保養更輕鬆愉悅。
      </p>
      <div class="row mt-4">
        <ProductListItem
          v-for="product in mousaProductList"
          :key="product.id"
          :id="product.id"
          :image="product.image"
          :name="product.name"
          :subtitle="product.subtitle"
          :description="product.description"
          :imageLarge="product.imageLarge"
        />
      </div>
    </div>
  </section>
</template>
<script>
import ProductListItem from "@/components/public/ProductListItem";
export default {
  name: "MousaProductSection",
  components: {
    ProductListItem,
  },
  data() {
    return {
      mousaProductList: [
        {
          id: "5",
          name: "夢莎逆時雙效潔面乳Ⅱ",
          subtitle: "潔顏卸妝＋溫感按摩",
          description: "擁有微溫感的卸妝感受",
          image: require("@/assets/public/images/products/夢莎逆時雙效潔面乳Ⅱ.png"),
          imageLarge: true,
        },
        {
          id: "6",
          name: "夢莎逆時雙效洗顏霜Ⅱ",
          subtitle: "洗顏+潔顏卸妝",
          description: "綿密細緻的泡泡確實潔淨肌膚的每個角落",
          image: require("@/assets/public/images/products/夢莎逆時雙效洗顏霜Ⅱ.png"),
          imageLarge: true,
        },
        {
          id: "7",
          name: "夢莎逆時雙效洗顏皂Ⅱ",
          subtitle: "洗顏+泡泡面膜",
          description: "綿密豐盈的泡泡徹底洗淨肌膚",
          image: require("@/assets/public/images/products/夢莎逆時雙效洗顏皂Ⅱ.png"),
          imageLarge: false,
        },
        {
          id: "8",
          name: "夢莎逆時雙效賦活露Ⅱ",
          subtitle: "保濕+導入",
          description: "充滿水潤感",
          image: require("@/assets/public/images/products/夢莎逆時雙效賦活露Ⅱ.png"),
          imageLarge: true,
        },
        {
          id: "9",
          name: "夢莎逆時雙效潔賦活霜Ⅱ",
          subtitle: "保濕+導入",
          description: "長時間保持潤澤",
          image: require("@/assets/public/images/products/夢莎逆時雙效賦活霜Ⅱ.png"),
          imageLarge: false,
        },
        {
          id: "10",
          name: "夢莎逆時雙效賦活面膜Ⅱ",
          subtitle: "按摩+面膜",
          description: "去除毛孔髒污，肌膚更具透明感",
          image: require("@/assets/public/images/products/夢莎逆時雙效賦活面膜Ⅱ.png"),
          imageLarge: true,
        },
      ],
    };
  },
};
</script>